 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBOOKVR0245 from '@/components/eBookVR0245'
 import EBOOKVR02451 from '@/components/eBookVR02451'
 import LOVE_1 from '@/components/love_1'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import EBOOKVR02452 from '@/components/eBookVR02452'
 import EBOOKVR02453 from '@/components/eBookVR02453'
 import EBOOKVR02454 from '@/components/eBookVR02454'
 import EBOOKVR02455 from '@/components/eBookVR02455'
 import EBOOKVR02456 from '@/components/eBookVR02456'
 import EBOOKVR02457 from '@/components/eBookVR02457'
 import EBOOKVR02458 from '@/components/eBookVR02458'
 import EBOOKVR02459 from '@/components/eBookVR02459'
 import EBOOKVR024510 from '@/components/eBookVR024510'
 import EBOOKVR024511 from '@/components/eBookVR024511'
 import EBOOKVR024512 from '@/components/eBookVR024512'
 import EBOOKVR024513 from '@/components/eBookVR024513'
 import EBOOKVR024514 from '@/components/eBookVR024514'
 import EBOOKVR024515 from '@/components/eBookVR024515'
 import EBOOKVR024516 from '@/components/eBookVR024516'
 import EBOOKVR024517 from '@/components/eBookVR024517'
 import EBOOKVR024518 from '@/components/eBookVR024518'
 import EBOOKVR024519 from '@/components/eBookVR024519'
 import EBOOKVR024520 from '@/components/eBookVR024520'
 import EBOOKVR024521 from '@/components/eBookVR024521'
 import EBOOKVR024522 from '@/components/eBookVR024522'
 import EBOOKVR024523 from '@/components/eBookVR024523'
 import EBOOKVR024524 from '@/components/eBookVR024524'
 import EBOOKVR024525 from '@/components/eBookVR024525'
 import EBOOKVR024526 from '@/components/eBookVR024526'
 import EBOOKVR024527 from '@/components/eBookVR024527'
 import EBOOKVR024528 from '@/components/eBookVR024528'
 import EBOOKVR024529 from '@/components/eBookVR024529'
 import EBOOKVR024530 from '@/components/eBookVR024530'
 import EBOOKVR024531 from '@/components/eBookVR024531'
 import EBOOKVR024532 from '@/components/eBookVR024532'
 import EBOOKVR024533 from '@/components/eBookVR024533'
 import EBOOKVR024534 from '@/components/eBookVR024534'
 import EBOOKVR024535 from '@/components/eBookVR024535'
 import EBOOKVR024536 from '@/components/eBookVR024536'
 import EBOOKVR024537 from '@/components/eBookVR024537'
 import EBOOKVR024538 from '@/components/eBookVR024538'
 import EBOOKVR024539 from '@/components/eBookVR024539'
 import EBOOKVR024540 from '@/components/eBookVR024540'
 import EBOOKVR024541 from '@/components/eBookVR024541'
 import EBOOKVR024542 from '@/components/eBookVR024542'
 import EBOOKVR024543 from '@/components/eBookVR024543'
 import EBOOKVR024544 from '@/components/eBookVR024544'
 import EBOOKVR024545 from '@/components/eBookVR024545'
 import EBOOKVR024546 from '@/components/eBookVR024546'
 import EBOOKVR024547 from '@/components/eBookVR024547'
 import EBOOKVR024548 from '@/components/eBookVR024548'
 import EBOOKVR024549 from '@/components/eBookVR024549'
 import EBOOKVR024550 from '@/components/eBookVR024550'
 import EBOOKVR024551 from '@/components/eBookVR024551'
 import EBOOKVR024552 from '@/components/eBookVR024552'
 import EBOOKVR024553 from '@/components/eBookVR024553'
 import EBOOKVR024554 from '@/components/eBookVR024554'
 import EBOOKVR024555 from '@/components/eBookVR024555'
 import EBOOKVR024556 from '@/components/eBookVR024556'
 import EBOOKVR024557 from '@/components/eBookVR024557'
 import EBOOKVR024558 from '@/components/eBookVR024558'
 import EBOOKVR024559 from '@/components/eBookVR024559'
 import EBOOKVR024560 from '@/components/eBookVR024560'
 import EBOOKVR024561 from '@/components/eBookVR024561'
 import EBOOKVR024562 from '@/components/eBookVR024562'
 import EBOOKVR024563 from '@/components/eBookVR024563'
 import EBOOKVR024564 from '@/components/eBookVR024564'
 import EBOOKVR024565 from '@/components/eBookVR024565'
 import EBOOKVR024566 from '@/components/eBookVR024566'
 import EBOOKVR024567 from '@/components/eBookVR024567'
 import EBOOKVR024568 from '@/components/eBookVR024568'
 import EBOOKVR024569 from '@/components/eBookVR024569'
 import EBOOKVR024570 from '@/components/eBookVR024570'
 import EBOOKVR024571 from '@/components/eBookVR024571'
 import EBOOKVR024572 from '@/components/eBookVR024572'
 import EBOOKVR024573 from '@/components/eBookVR024573'
 import EBOOKVR024574 from '@/components/eBookVR024574'
 import EBOOKVR024575 from '@/components/eBookVR024575'
 import EBOOKVR024576 from '@/components/eBookVR024576'
 import EBOOKVR024577 from '@/components/eBookVR024577'
 import EBOOKVR024578 from '@/components/eBookVR024578'
 import EBOOKVR024579 from '@/components/eBookVR024579'
 import EBOOKVR024580 from '@/components/eBookVR024580'
 import EBOOKVR024581 from '@/components/eBookVR024581'
 import EBOOKVR024582 from '@/components/eBookVR024582'
 import EBOOKVR024583 from '@/components/eBookVR024583'
 import EBOOKVR024584 from '@/components/eBookVR024584'
 import EBOOKVR024585 from '@/components/eBookVR024585'
 import LOVE_2 from '@/components/love_2'
 import MBMBTURN from '@/components/MB/MBturn'
 import MBMBCOVER from '@/components/MB/MBcover'
 import MBMB from '@/components/MB/MB'
 import MBMB1 from '@/components/MB/MB1'
 import EBOOKVR024586 from '@/components/eBookVR024586'
 import EBOOKVR024587 from '@/components/eBookVR024587'
 import EBOOKVR024588 from '@/components/eBookVR024588'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/eBookVR0245",
 			"name" : "eBookVR0245",
 			"component" : EBOOKVR0245
 		},
 		{
 			"path" : "/eBookVR02451",
 			"name" : "eBookVR02451",
 			"component" : EBOOKVR02451
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/eBookVR02452",
 			"name" : "eBookVR02452",
 			"component" : EBOOKVR02452
 		},
 		{
 			"path" : "/eBookVR02453",
 			"name" : "eBookVR02453",
 			"component" : EBOOKVR02453
 		},
 		{
 			"path" : "/eBookVR02454",
 			"name" : "eBookVR02454",
 			"component" : EBOOKVR02454
 		},
 		{
 			"path" : "/eBookVR02455",
 			"name" : "eBookVR02455",
 			"component" : EBOOKVR02455
 		},
 		{
 			"path" : "/eBookVR02456",
 			"name" : "eBookVR02456",
 			"component" : EBOOKVR02456
 		},
 		{
 			"path" : "/eBookVR02457",
 			"name" : "eBookVR02457",
 			"component" : EBOOKVR02457
 		},
 		{
 			"path" : "/eBookVR02458",
 			"name" : "eBookVR02458",
 			"component" : EBOOKVR02458
 		},
 		{
 			"path" : "/eBookVR02459",
 			"name" : "eBookVR02459",
 			"component" : EBOOKVR02459
 		},
 		{
 			"path" : "/eBookVR024510",
 			"name" : "eBookVR024510",
 			"component" : EBOOKVR024510
 		},
 		{
 			"path" : "/eBookVR024511",
 			"name" : "eBookVR024511",
 			"component" : EBOOKVR024511
 		},
 		{
 			"path" : "/eBookVR024512",
 			"name" : "eBookVR024512",
 			"component" : EBOOKVR024512
 		},
 		{
 			"path" : "/eBookVR024513",
 			"name" : "eBookVR024513",
 			"component" : EBOOKVR024513
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js